import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { memo, useEffect, useMemo, useState } from 'react';
import { addSubscriptionPurchase } from 'services/subscription';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { getPackageListRequest } from 'store/reducers/package/actionType';

interface PopupAddPackageProps {
  open: boolean;
  activePackageIds: string[];
  parentId: string;
  onSuccess: () => void;
  handleClosePopup: () => void;
}

const PopupAddPackage = memo(
  ({
    open,
    activePackageIds,
    parentId,
    onSuccess,
    handleClosePopup,
  }: PopupAddPackageProps) => {
    const dispatch = useAppDispatch();

    const { package_list } = useAppSelector(
      (state) => state.packageReducer.package
    );

    const { params, records } = package_list;

    useEffect(() => {
      if (params) {
        dispatch(getPackageListRequest(params));
      }
    }, [params, dispatch]);

    const activePackageIdSet = useMemo(() => {
      return new Set(activePackageIds);
    }, [activePackageIds]);

    const [selected, setSelected] = useState<string>('');

    useEffect(() => {
      if (!open) {
        setSelected('');
      }
    }, [open]);

    const handleSave = async () => {
      if (!selected) return;

      await addSubscriptionPurchase({
        parent_id: parentId,
        package_id: selected,
      });

      onSuccess();
      handleClosePopup();
    };

    return (
      <Dialog open={open} onClose={handleClosePopup} fullWidth maxWidth="sm">
        <DialogTitle>Select Package</DialogTitle>

        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="package-select-label">Choose Package</InputLabel>

            <Select
              labelId="package-select-label"
              value={selected}
              label="Choose Package"
              onChange={(e) => setSelected(e.target.value)}
            >
              {records?.map((pkg) => (
                <MenuItem
                  key={pkg.id}
                  value={pkg.id}
                  disabled={
                    activePackageIdSet.size > 0 &&
                    !activePackageIdSet.has(pkg.id)
                  }
                >
                  {pkg.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClosePopup}>Cancel</Button>

          <Button variant="contained" disabled={!selected} onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default PopupAddPackage;
